import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';
import Button from '../../components/Button';
import { __ } from '../../utilities';
import { favouritePassengersPropType } from './types';

const Wrapper = styled.div``;

const BORDER_COLOR = '#ddd';

const Row = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  border-bottom: ${rem(1)} solid ${BORDER_COLOR};
  &:nth-child(1) {
    border-top: ${rem(1)} solid ${BORDER_COLOR};
  }
  &:hover {
    background: #f1f1f1;
  }
`;

const Cell = styled.div`
  padding: 0.5rem 1rem;
`;

const ActionCell = styled(Cell)`
  margin-left: auto;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: ${rem(18)};
`;

const Subtitle = styled.div`
  color: #777;
`;

class List extends React.Component {
  renderRow = (passenger, idx, isSelected) => (
    <Row key={idx} onClick={() => this.props.onSelect(idx)}>
      <Cell>
        <Title>
          {passenger.username} {passenger.surname}
        </Title>
        <Subtitle>{passenger.email}</Subtitle>
      </Cell>
      <ActionCell>
        {isSelected ? (
          <Button danger onClick={() => this.props.onSelect(idx)}>
            {__('Odstrániť z výberu')}
          </Button>
        ) : (
          this.props.selectable && (
            <Button primary onClick={() => this.props.onSelect(idx)}>
              {__('Vybrať')}
            </Button>
          )
        )}
      </ActionCell>
    </Row>
  );

  render() {
    const { passengers, selectedIdxs } = this.props;
    return (
      <Wrapper>
        {passengers.map((passenger, idx) =>
          this.renderRow(passenger, idx, selectedIdxs.includes(idx)),
        )}
      </Wrapper>
    );
  }
}

List.propTypes = {
  selectable: PropTypes.bool.isRequired,
  passengers: favouritePassengersPropType.isRequired,
  selectedIdxs: PropTypes.arrayOf(PropTypes.number).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default List;



// WEBPACK FOOTER //
// ./src/containers/FavouritePassengers/List.js